/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
/* eslint-disable indent */
//@ts-nocheck
import React from "react";
import styled from "styled-components";
import { useField } from "formik";
import { TextLight } from "../styles";
import InlineLink from "./InlineLink";
interface InputProps {
    value: string;
    label: string;
    type: string;
    name: string;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

interface MainInputProps {
    error: boolean;
}

const CheckBox: React.FC<InputProps> = (props) => {
    const { value, label, name, type, onBlur, onChange, link, textLink } = props;
    const [field, meta] = useField<{}>(props);
    const errorText = meta.error && meta.touched ? meta.error : "";
    return (
        <Wrapper>
            <MainInput
                error={!!errorText}
                name={name}
                onBlur={onBlur}
                onChange={onChange}
                type={type}
                value={value}
            />
            <Label style={{marginLeft:"10px"}}>{link ? <InlineLink 
                                    text={label}
                                    textLink={textLink}
                                    handleView={() => window.open(link, "_blank")}
                                    /> :label}</Label>
            {errorText && <Error>{errorText}</Error>}
        </Wrapper>
    );
};

const Wrapper = styled.div`
    display: flex;
    align-items: center;
`;

const Label = styled(TextLight)``;

const MainInput = styled.input<MainInputProps>`
    background-color: ${({ error }) =>
        error ? "rgba(255, 145, 145, 0.3)" : "rgba(255, 255, 255, 0.3)"};
    border-radius: 5px;
    box-shadow: ${({ error }) =>
        error &&
        "rgba(235, 12, 12, 0.3) 0px 10px 40px, rgba(227, 32, 32, 1) 0px 0px 0px 1px inset"};
    color: white;
    outline: none;
    transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1) 0s;
   

    &:focus {
        background-color: rgba(0, 0, 0, 0.3);
        box-shadow: ${({ error }) =>
            !error &&
            "rgba(12, 235, 235, 0.3) 0px 10px 40px, rgb(32, 227, 178) 0px 0px 0px 1px inset"};
    }
`;

const Error = styled(TextLight)`
    font-size: 10px;
    text-transform: capitalize;
`;

const TermsLink = styled.a`
    color: "rgb(32, 227, 178)";
    text-decoration:none;
`;

export default CheckBox;
